import React from "react";
import "../../../css/YearAll.css";
import mobility from "../../../img/ride.png";

interface YearAllProps {
  YearAll: number;
}

const YearAll = ({ YearAll }: YearAllProps) => {
  return (
    <div className="year_all_container">
      <div className="year_all_display">
        <img className="mobility" src={mobility} />
        <div className="year_all_title">今期のライド金額</div>
      </div>
      <div className="year_all_of">
        {YearAll.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default YearAll;
